<template>
  <a @click="generateQrCode">
    <MIcon name="qrcode" class="action-menu-icon" />
    <span class="ml-1 action-menu-text">
      {{ $t('print') }} {{ $tc('qrcode') }}
    </span>
  </a>
</template>

<script>
import { generateQrCodeForAssetUsingQrData, generatePdf } from '@utils/qrcode'
import { generateQrCodeApi } from '../../asset-api'

export default {
  name: 'PrintQrCode',
  props: {
    moduleName: { type: String, required: true },
    resourceId: { type: Number, required: true },
    resource: { type: Object, required: true },
  },
  methods: {
    generateQrCode() {
      generateQrCodeApi(this.moduleName, [this.resourceId]).then((data) => {
        generateQrCodeForAssetUsingQrData(data[0]).then((qrcodeStr) => {
          generatePdf([qrcodeStr], `${this.resource.name}-qrcode.pdf`)
        })
        this.$emit('done')
      })
    },
  },
}
</script>
